import { Form } from '@/components';
import styled from 'styled-components';

export const StyledWrapper = styled.div`
  display: flex;
  gap: 1rem;
  margin-top: 1.5rem;
  justify-content: space-between;
`;

export const StyledForm = styled(Form)`
  display: flex;
  flex-direction: column;
`;
